import { classNames } from "primereact/utils";
import styles from "./MessageBanner.module.scss";
import { useAppContext } from "../../../../AppContext";


import { dvSize } from "../../../infrastructure/utilities/viewportUnitsUtility";
interface IMessageBannerProps {
  className?: string;
  message: string;
  type: "warning" | "info" | "error";
  icon?: string;
  width?: string;
  /** Bold first line above the message, for a banner that has to be read at a glance. */
  title?: string;
}

const defaultIcons: Record<IMessageBannerProps["type"], string> = {
  warning: "pi pi-exclamation-triangle",
  info: "pi pi-info-circle",
  error: "pi pi-times-circle",
};

export const MessageBanner = ({
  className,
  message,
  type,
  icon,
  width,
  title,
}: IMessageBannerProps) => {
  const iconClass = icon ?? defaultIcons[type];
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }

  return (
    <div
      className={classNames(styles.root, className, {
        [styles.root_warning]: type === "warning",
        [styles.root_info]: type === "info",
        [styles.root_error]: type === "error",
      })}
      style={{ width, maxWidth: width }}
    >
      <i className={classNames(styles.root_icon, iconClass)} />
      <span className={styles.root_message}>
        {title && <strong className={styles.root_message_title}>{title}</strong>}
        {message}
      </span>
    </div>
  );
};
